import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { LOGO, TRUST } from "../../lib/data";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory px-5">
      <div className="w-full max-w-md border border-gold/25 bg-white p-10">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="logo" className="h-11 w-11 object-contain" />
          <div>
            <div className="font-serif text-lg text-maroon">{TRUST.name}</div>
            <div className="text-xs text-ink-muted">Administrator Sign In</div>
          </div>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div><Label htmlFor="a-email">Email</Label><Input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="mt-2" /></div>
          <div><Label htmlFor="a-pass">Password</Label><Input id="a-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="mt-2" /></div>
          {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="flex w-full items-center justify-center gap-2 bg-maroon px-6 py-3.5 text-xs uppercase tracking-wide text-ivory hover:bg-maroon-dark disabled:opacity-60">
            {busy ? "Signing in..." : <><LogIn size={16} /> Sign In</>}
          </button>
        </form>
        <p className="mt-6 flex items-center gap-2 text-xs text-ink-muted"><ShieldCheck size={14} /> Secure area — authorised administrators only.</p>
      </div>
    </div>
  );
}
